import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';

import type { ExperienceResponse } from 'app/typings/core/admin/experiences/experience';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

type ExperiencesListQueryParam = {
  withStaycationExperiences?: boolean;
};

type ExperiencesResponse = {
  experiences: ExperienceResponse[];
};

export function useGetExperiencesByHotelId(
  id?: string | number,
  queryParams: ExperiencesListQueryParam = {}
) {
  const hotelId = id?.toString();

  return useQuery({
    queryKey: [CORE_QUERY_KEYS.experiences, { id: hotelId, ...queryParams }],
    queryFn: hotelId
      ? () =>
          apiRequest({
            path: ENDPOINTS.getExperiencesByHotelId,
            params: { id: hotelId },
            queryParams,
          }) as Promise<ExperiencesResponse>
      : () => Promise.resolve(undefined),
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    enabled: !!hotelId,
  });
}
